<template>
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.52266 2.5226L2.52074 2.52041C2.47227 2.47233 2.41479 2.43427 2.35161 2.4084C2.28842 2.38253 2.22076 2.36935 2.15248 2.36963C2.08421 2.36991 2.01665 2.38364 1.95368 2.41002C1.89071 2.43641 1.83355 2.47494 1.78547 2.52342C1.73739 2.57189 1.69932 2.62937 1.67345 2.69255C1.64758 2.75574 1.63441 2.8234 1.63469 2.89168C1.63526 3.02957 1.69057 3.16159 1.78848 3.25869L2.57242 4.04264C1.62171 4.69376 0.80338 5.5196 0.160976 6.47623C0.0560714 6.63111 0 6.81389 0 7.00096C0 7.18802 0.0560714 7.3708 0.160976 7.52568C1.80078 9.95271 4.40035 11.3746 6.99992 11.3568C7.84196 11.3599 8.6784 11.2197 9.47344 10.9423L10.7425 12.2113C10.8402 12.3059 10.9712 12.3584 11.1073 12.3575C11.2433 12.3566 11.3736 12.3023 11.4701 12.2064C11.5666 12.1104 11.6216 11.9805 11.6232 11.8444C11.6249 11.7084 11.5732 11.5771 11.4791 11.4788L2.52266 2.5226ZM6.99992 9.9456C6.5074 9.94542 6.02279 9.82181 5.59036 9.58606C5.15792 9.35032 4.79147 9.00995 4.52448 8.59608C4.2575 8.18221 4.09849 7.70802 4.062 7.21686C4.02551 6.72569 4.11269 6.23322 4.31559 5.78443L5.13453 6.60338C5.06857 6.91422 5.08131 7.23662 5.17161 7.54128C5.26191 7.84595 5.4269 8.12322 5.6516 8.34791C5.87629 8.57261 6.15356 8.7376 6.45823 8.8279C6.76289 8.9182 7.08529 8.93094 7.39613 8.86498L8.21508 9.68393C7.83338 9.85699 7.41902 9.94623 6.99992 9.9456Z"
            fill="#666666"
        />
        <path
            d="M13.8388 6.47488C12.199 4.04648 9.59939 2.6246 6.99982 2.64238C6.15777 2.63933 5.32134 2.7795 4.5263 3.05691L5.78411 4.31472C6.32992 4.06772 6.93804 3.99293 7.52743 4.10031C8.11682 4.20769 8.65948 4.49215 9.08311 4.91577C9.50673 5.33939 9.79119 5.88206 9.89857 6.47145C10.0059 7.06084 9.93116 7.66896 9.68415 8.21476L11.427 9.95765C12.3779 9.30663 13.1964 8.48077 13.8388 7.52406C13.9436 7.3692 13.9996 7.18648 13.9996 6.99947C13.9996 6.81245 13.9436 6.62973 13.8388 6.47488Z"
            fill="#666666"
        />
        <path
            d="M6.60397 5.13423C6.73423 5.10661 6.86703 5.09268 7.00018 5.09267C7.28421 5.09267 7.56465 5.15612 7.82102 5.27838C8.07739 5.40063 8.30321 5.57862 8.48199 5.79932C8.66076 6.02003 8.78798 6.27788 8.85434 6.55405C8.92071 6.83022 8.92455 7.11772 8.86557 7.39556L6.60397 5.13423Z"
            fill="#666666"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
